module.exports = __webpack_public_path__ + "static/media/SaniBot.10f6d3c8.jpg";